import React, { useMemo } from 'react';
import ServicePanel from "../../../ServicePanel/ServicePanel";
import { getServiceChangeBullets } from "../../../../business-logic/amendmentsLogic";
import { approvalMethodModel, serviceModel } from "../../../../models";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
export default function AgreementServiceInstance(props) {
  const {
    service,
    idx,
    agreement,
    agreementData,
    isVendor
  } = props;
  const approvalMethod = serviceModel.approvalMethod(service);
  const autoApprovalDate = approvalMethod ? approvalMethodModel.autoApprovalDate(approvalMethod) : null;
  const changeBullets = useMemo(() => {
    return serviceModel.isCompleted(service.status) ? [] : getServiceChangeBullets(service);
  }, [service]);
  return /*#__PURE__*/React.createElement(ServicePanel, {
    service: service,
    idx: idx,
    agreementStatus: agreement.status,
    agreementData: agreementData,
    isVendor: isVendor,
    footer: changeBullets.length > 0 && /*#__PURE__*/React.createElement(AmendmentChangesInAgreementView, {
      items: changeBullets,
      autoApprovalDate: autoApprovalDate,
      existingNote: serviceModel.note(service),
      testid: "service-".concat(idx, "-changes")
    })
  });
}